export default __webpack_public_path__ + "static/tetanus-eedf2afbce40e956529cd7099b4f6ad2.png";